import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class PreLoginAuthGuard implements CanActivate {
  returnToParam: any;
  urlParams: URLSearchParams;
  brandingIdParam: string | null;
  message: string | null;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.urlParams = new URLSearchParams(window.location.search);
    this.returnToParam = this.urlParams.get('return_to');
    this.brandingIdParam = this.urlParams.get('brand_id');
    this.message = this.urlParams.get('message');
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // If Route is not the path of fcHypbridRoute, then redirect to fcConnectHostPath.
    if (!this.isFcHypbridRoute(state.url)) {
      let fcConnectRedirectPath = environment.fcConnectHostPath;

      // routeRedirectPath would be overwrite with download software path if the requested url is software download.
      if (this.isDownloadSoftwareRoute(state.url)) {
        fcConnectRedirectPath = environment.fcConnectDownloadSoftwarePath;
      }

      window.location.replace(fcConnectRedirectPath);
      return false;
    }
    return true;
  }

  isFcHypbridRoute(url: string) {
    const fcHypbridRoute = [
      '/equipmentSettings/announcement',
      '/equipmentSettings/entertainment',
      '/equipmentSettings/entertainment/iptv',
      '/equipmentSettings/entertainment/apps',
      '/equipmentSettings/entertainment/internet',
      '/manageFeatureFlags',
    ];
    if (!fcHypbridRoute.includes(url)) {
      return false;
    }
    return true;
  }

  isDownloadSoftwareRoute(url: string): boolean {
    const softwareDownloadRoute = ['/softwareDownload'];
    if (!softwareDownloadRoute.includes(url)) {
      return false;
    }
    return true;
  }
}
